import {
	ADD_PRODUCT,
	ADD_PRODUCTS_BY_REF,
	ADD_PRODUCTS,
	CREATE_PROJECT,
	DELETE_PRODUCT,
	DELETE_PROJECT,
	UPDATE_PRODUCT,
	CREATE_REQUEST_BUDGET,
	MODAL_PROJECT_CLOSE,
	ADD_MODEL_STANDARD,
	CLOSE_MODAL_ADD_PRODUCT,
	NEW_THIRD_PARTY_PROJECT,
} from '@/redux/actions/project.actions'
import { FILE_DOWNLOAD_METRICS } from '@/redux/actions/socket.actions'
import { LANGUAGE_LOCALES_CODE } from '@/constants'

const createProjectSuccess = (action) => {
	return {
		event: 'eventoGA',
		eventCat: 'new project',
		eventAct: action.payload.id,
		eventLbl: action.payload.name
	}
}

const createProjectFailure = (action) => ({
	eventCat: 'new project error',
	eventAct: '',
	eventLbl: action.error.message
})

const addProductSuccess = (action, prevState) => {
	const productLang = LANGUAGE_LOCALES_CODE[prevState.i18n.locale]
	const product = action.payload.product
	return {
		event: 'eventoGA',
		eventCat: product.type == 'CREATION' ? 'add creation product to project' : 'add model to project',
		eventAct: `${product.subFamily.description} - ${product.applicationLocation.application.shortDescription[productLang]}`,
		eventLbl: product.type == 'CREATION' ? product.configuratorType?.description : product.productCode
	}
}

const addProductsByRefSuccess = (action) => {
	return action.payload.referencesDetails.map((reference) => ({
		event: 'eventoGA',
		eventCat: reference.type == 'CREATION' ? 'add creation product to project' : 'add standard product to project',
		eventAct: `${action.payload.collection.subFamily.description} - ${action.payload.collection.applicationLocation.application.shortDescription}`,
		eventLbl: reference.type == 'CREATION' ? reference.configuratorType?.description : reference?.model
	}))
}

const addProductsSuccess = (action, prevState) => {
	const productLang = LANGUAGE_LOCALES_CODE[prevState.i18n.locale]
	return action.payload.products.map((product) => ({
		event: 'eventoGA',
		eventCat: product.type == 'CREATION' ? 'add creation product to project' : 'add model to project',
		eventAct: `${product.subFamily.description} - ${product.applicationLocation.application.shortDescription[productLang]}`,
		eventLbl: product.type == 'CREATION' ? product.configuratorType?.description : product.productCode
	}))
}

const addProductByRefFailure = (action) => {
	return {
		event: 'eventoGA',
		eventCat: 'add standard product to project error',
		eventAct: action.error.message
	}
}

const createRequestBudgetSuccess = (action) => {
	return {
		event: 'eventoGA',
		eventCat: 'Support Request',
		eventAct: action.payload?.project,
		eventLbl: ''
	}
}

const createRequestBudgetError = (action) => {
	return {
		event: 'eventoGA',
		eventCat: 'Support Request error',
		eventAct: action.payload?.message,
		eventLbl: ''
	}
}

const updateProductSuccess = (action, prevState) => {
	const product = prevState.project.details.products.byId[action.payload.productId]
	return {
		event: 'eventoGA',
		eventCat: product.type == 'REGULAR' ? 'standard product personalization' : 'creation product personalization',
		eventAct: `${product.subFamily.description} - ${product.applicationLocation.application.shortDescription}`,
		eventLbl: product.type == 'REGULAR' ? product.model : product.configuratorType?.description
	}
}

const deleteProductSuccess = (_, prevState) => {
	const product = prevState.project.details.products.byId[prevState.project.deletingProduct.productId]
	return {
		event: 'eventoGA',
		eventCat:
			product.type == 'REGULAR' ? 'delete standard product from project' : 'delete creation product from project',
		eventAct: `${product.subFamily.description} - ${product.applicationLocation.application.shortDescription}`,
		eventLbl: product.type == 'REGULAR' ? product.model : product.configuratorType?.description
	}
}

const deleteProjectSuccess = (action) => {
	return {
		event: 'eventoGA',
		eventCat: 'project deleted',
		eventAct: '' + action.payload.projectId,
		eventLbl: action.payload.projectName
	}
}

const newThirdPartyProject = (action) => {
	return {
		event: 'eventoGA',
		eventCat: 'new third party project',
		eventAct: '' + action.payload.projectId,
		eventLbl: action.payload.projectName
	}
}

const modalProjectClose = (action) => {
	return {
		event: 'eventoGA',
		eventCat: 'new project error',
		eventAct: action.payload.message,
		eventLbl: ''
	}
}

const addModelStandard = (action) => {
	return {
		event: 'eventoGA',
		eventCat: 'add model to project',
		eventAct: action.payload.information,
		eventLbl: action.payload.code,
	}
}

const closeModalAddProduct = (action) => {
	return {
		event: 'eventoGA',
		eventCat: 'add standard product to project error',
		eventAct: action.payload.message,
		eventLbl: '',
	}
}

const fileDownloadMetrics = (action) => {
	return {
		event: 'eventoGA',
		eventCat: 'Downloads',
		eventAct: action.payload.typeProducts,
		eventLbl: action.payload.typeDownload,
	}
}

export default {
	[CREATE_PROJECT.SUCCESS]: createProjectSuccess,
	[CREATE_PROJECT.FAILURE]: createProjectFailure,
	[ADD_PRODUCT.SUCCESS]: addProductSuccess,
	[ADD_PRODUCTS_BY_REF.SUCCESS]: addProductsByRefSuccess,
	[ADD_PRODUCTS.SUCCESS]: addProductsSuccess,
	[UPDATE_PRODUCT.SUCCESS]: updateProductSuccess,
	[ADD_PRODUCTS_BY_REF.FAILURE]: addProductByRefFailure,
	[DELETE_PRODUCT.SUCCESS]: deleteProductSuccess,
	[DELETE_PROJECT.SUCCESS]: deleteProjectSuccess,
	[MODAL_PROJECT_CLOSE]: modalProjectClose,
	[ADD_MODEL_STANDARD]: addModelStandard,
	[CLOSE_MODAL_ADD_PRODUCT]: closeModalAddProduct,
	[CREATE_REQUEST_BUDGET.SUCCESS]: createRequestBudgetSuccess,
	[CREATE_REQUEST_BUDGET.FAILURE]: createRequestBudgetError,
	[NEW_THIRD_PARTY_PROJECT]: newThirdPartyProject,
	[FILE_DOWNLOAD_METRICS]: fileDownloadMetrics,
}
